var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_1946488",
    clipPath: "url(#clip0_0_6845)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.5792 9.65068C20.5786 9.65022 20.5781 9.6496 20.5776 9.64914L12.3504 1.42304C11.9997 1.07224 11.5335 0.87915 11.0375 0.87915C10.5416 0.87915 10.0754 1.07224 9.72453 1.42304L1.50161 9.64499C1.49884 9.64775 1.49592 9.65068 1.4933 9.65345C0.773165 10.3777 0.774396 11.5527 1.49684 12.2751C1.8269 12.6052 2.26268 12.7963 2.72876 12.8165C2.74784 12.8183 2.76692 12.8193 2.78616 12.8193H3.11391V18.873C3.11391 20.0711 4.08886 21.0458 5.28709 21.0458H8.50585C8.83221 21.0458 9.09673 20.7812 9.09673 20.455V15.7087C9.09673 15.1621 9.54158 14.7174 10.0883 14.7174H11.9868C12.5335 14.7174 12.9782 15.1621 12.9782 15.7087V20.455C12.9782 20.7812 13.2427 21.0458 13.5691 21.0458H16.7879C17.9862 21.0458 18.961 20.0711 18.961 18.873V12.8193H19.2651C19.7609 12.8193 20.2271 12.6262 20.5781 12.2752C21.3013 11.5518 21.3016 10.3746 20.5792 9.65068ZM19.7424 11.4398C19.6149 11.5673 19.4453 11.6376 19.2651 11.6376H18.3702C18.0438 11.6376 17.7793 11.9021 17.7793 12.2284V18.873C17.7793 19.4195 17.3346 19.8642 16.7879 19.8642H14.16V15.7087C14.16 14.5106 13.1852 13.5358 11.9868 13.5358H10.0883C8.88992 13.5358 7.91497 14.5106 7.91497 15.7087V19.8642H5.28709C4.74052 19.8642 4.29567 19.4195 4.29567 18.873V12.2284C4.29567 11.9021 4.03116 11.6376 3.70479 11.6376H2.82524C2.81601 11.637 2.80693 11.6365 2.79754 11.6364C2.62151 11.6333 2.4564 11.5635 2.33269 11.4396C2.06956 11.1765 2.06956 10.7483 2.33269 10.4851C2.33284 10.4851 2.33284 10.4849 2.333 10.4847L2.33346 10.4843L10.5604 2.2585C10.6878 2.13095 10.8572 2.06079 11.0375 2.06079C11.2177 2.06079 11.3872 2.13095 11.5147 2.2585L19.7398 10.4826C19.741 10.4838 19.7424 10.4851 19.7436 10.4863C20.0054 10.7498 20.0049 11.1771 19.7424 11.4398Z",
    fill: "#5E5E5E",
    stroke: "#4a4a4a",
    strokeWidth: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_6845"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.ddf8d10fed4a447f16a068a9825c4e68.svg";
export { ForwardRef as ReactComponent };